import axios from "axios";
import actions from "./actions";
import { getFilterUrlPart } from "../../lib/utils";
import _ from "lodash";

const fetchBestWorst = (id, options) => (dispatch, getState) => {
  dispatch(actions.fetchBestWorstStart());
  const { units, token, survey, actualSurvey, appliedBenchmark, configuration } = options;
  const unitsParam = units
    ? `&units='${_.map(units, function(unit) {
      return encodeURIComponent(unit); //unit.replace(/&/g, "%26");
    }).join(`','`)}'`
    : "";
  const filterParams = getFilterUrlPart(getState().filters);

  const additionalQueryString = `&token=${token}&version=${actualSurvey}${unitsParam}&benchmarks=${appliedBenchmark}`;
  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch(err => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchBestWorstError(err));
      }
    });
  }
  function getBestWorst(url) {
    return retryOnFail(function() {
      return axios.get(url);
    });
  }

  const promises = [];
  const showEngagement = configuration.show_engagement || survey === 'SCORE' || survey === 'SELECT_2020' || survey === 'SHA_2020';
  promises.push(
    getBestWorst(`/api/survey/${id}/bestWorst?questionFilter=culture&classification=best${additionalQueryString}${filterParams}`)
  );
  promises.push(
    getBestWorst(`/api/survey/${id}/bestWorst?questionFilter=culture&classification=worst${additionalQueryString}${filterParams}`)
  );
  if (showEngagement) {
    promises.push(
      getBestWorst(`/api/survey/${id}/bestWorst?questionFilter=engagement&classification=best${additionalQueryString}${filterParams}`)
    );
    promises.push(
      getBestWorst(`/api/survey/${id}/bestWorst?questionFilter=engagement&classification=worst${additionalQueryString}${filterParams}`)
    );
  }
  Promise.all(promises).then(results => {
    dispatch(
      actions.fetchBestWorst({
        cultureBest: results[0].data,
        cultureWorst: results[1].data,
        engagementBest: showEngagement && results[2].data,
        engagementWorst: showEngagement && results[3].data,
      })
    );
  });
};

const clearProgress = () => (dispatch, getState) => {
  dispatch(actions.fetchBestWorstStart());
};

export default {
  fetchBestWorst,
  clearProgress,
};



// WEBPACK FOOTER //
// ./src/redux/bestWorst/operations.js